import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpGatewayService } from '../services/http-gateway.service';
import { MaintenanceStatusContract } from '../store/maintenance/types';

@Injectable({ providedIn: 'root' })
export class MaintenanceApi {
  private httpService = inject(HttpGatewayService);

  public getStatus(): Observable<MaintenanceStatusContract> {
    return this.httpService.get<MaintenanceStatusContract>('/maintenance');
  }

  public setMaintenance(
    enabled: boolean,
  ): Observable<MaintenanceStatusContract> {
    return this.httpService.put<MaintenanceStatusContract>('/maintenance', {
      enabled,
    });
  }
}
